import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const postCertificate = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.DISTRIBUTE.POST_CERTIFICATE,
    data
  );
};

export default postCertificate;
